import type {TicketStatus} from '../types/ticket';

export interface BoardColumnSpec {
	status: TicketStatus;
	label: string;
	// Hex color for the status indicator dot in the column header (ACC-523:
	// ported from the Tailwind *-500 class the dot previously used).
	dotColor: string;
}

// Order matches the mockup left-to-right: Open → In progress → Waiting → Resolved → Closed.
// Note: the schema enum has no `new` or `blocked`. The mockup's `New`/`Blocked` columns
// are illustrative; we render the actual enum values per the design decision doc.
export const BOARD_COLUMNS: readonly BoardColumnSpec[] = [
	{status: 'open', label: 'Open', dotColor: '#3b82f6'}, // blue-500
	{status: 'in_progress', label: 'In progress', dotColor: '#eab308'}, // yellow-500
	{status: 'waiting_on_customer', label: 'Waiting on customer', dotColor: '#f97316'}, // orange-500
	{status: 'resolved', label: 'Resolved', dotColor: '#10b981'}, // emerald-500
	{status: 'closed', label: 'Closed', dotColor: '#94a3b8'}, // slate-400
] as const;

export const BOARD_STATUSES: readonly TicketStatus[] = BOARD_COLUMNS.map(c => c.status);
